// @generated by protobuf-ts 2.11.1
// @generated from protobuf file "exchangeRate.proto" (package "currency", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { ExchangeRateService } from "./exchangeRate";
import type { TestGetCurrencyRateResponse } from "./exchangeRate";
import type { TestGetCurrencyRateRequest } from "./exchangeRate";
import type { DeleteExchangeRateResponse } from "./exchangeRate";
import type { DeleteExchangeRateRequest } from "./exchangeRate";
import type { UpdateExchangeRateResponse } from "./exchangeRate";
import type { UpdateExchangeRateRequest } from "./exchangeRate";
import type { CreateExchangeRateResponse } from "./exchangeRate";
import type { CreateExchangeRateRequest } from "./exchangeRate";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetAllExchangeRateResponse } from "./exchangeRate";
import type { GetAllExchangeRateRequest } from "./exchangeRate";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service currency.ExchangeRateService
 */
export interface IExchangeRateServiceClient {
    /**
     * @generated from protobuf rpc: GetAllExchangeRate
     */
    getAllExchangeRate(input: GetAllExchangeRateRequest, options?: RpcOptions): UnaryCall<GetAllExchangeRateRequest, GetAllExchangeRateResponse>;
    /**
     * @generated from protobuf rpc: CreateExchangeRate
     */
    createExchangeRate(input: CreateExchangeRateRequest, options?: RpcOptions): UnaryCall<CreateExchangeRateRequest, CreateExchangeRateResponse>;
    /**
     * @generated from protobuf rpc: UpdateExchangeRate
     */
    updateExchangeRate(input: UpdateExchangeRateRequest, options?: RpcOptions): UnaryCall<UpdateExchangeRateRequest, UpdateExchangeRateResponse>;
    /**
     * @generated from protobuf rpc: DeleteExchangeRate
     */
    deleteExchangeRate(input: DeleteExchangeRateRequest, options?: RpcOptions): UnaryCall<DeleteExchangeRateRequest, DeleteExchangeRateResponse>;
    /**
     * @generated from protobuf rpc: TestGetCurrencyRate
     */
    testGetCurrencyRate(input: TestGetCurrencyRateRequest, options?: RpcOptions): UnaryCall<TestGetCurrencyRateRequest, TestGetCurrencyRateResponse>;
}
/**
 * @generated from protobuf service currency.ExchangeRateService
 */
export class ExchangeRateServiceClient implements IExchangeRateServiceClient, ServiceInfo {
    typeName = ExchangeRateService.typeName;
    methods = ExchangeRateService.methods;
    options = ExchangeRateService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: GetAllExchangeRate
     */
    getAllExchangeRate(input: GetAllExchangeRateRequest, options?: RpcOptions): UnaryCall<GetAllExchangeRateRequest, GetAllExchangeRateResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAllExchangeRateRequest, GetAllExchangeRateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateExchangeRate
     */
    createExchangeRate(input: CreateExchangeRateRequest, options?: RpcOptions): UnaryCall<CreateExchangeRateRequest, CreateExchangeRateResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateExchangeRateRequest, CreateExchangeRateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateExchangeRate
     */
    updateExchangeRate(input: UpdateExchangeRateRequest, options?: RpcOptions): UnaryCall<UpdateExchangeRateRequest, UpdateExchangeRateResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateExchangeRateRequest, UpdateExchangeRateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteExchangeRate
     */
    deleteExchangeRate(input: DeleteExchangeRateRequest, options?: RpcOptions): UnaryCall<DeleteExchangeRateRequest, DeleteExchangeRateResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteExchangeRateRequest, DeleteExchangeRateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: TestGetCurrencyRate
     */
    testGetCurrencyRate(input: TestGetCurrencyRateRequest, options?: RpcOptions): UnaryCall<TestGetCurrencyRateRequest, TestGetCurrencyRateResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<TestGetCurrencyRateRequest, TestGetCurrencyRateResponse>("unary", this._transport, method, opt, input);
    }
}
